// store/balance/useBalanceStore.ts

import { create } from 'zustand';
import { persist, combine } from 'zustand/middleware';
import { balanceInitialState } from './balanceInitialState';
import { createBalanceSlice } from './createBalanceSlice';
import type { BalanceState } from './balanceInitialState';
import type { BalanceActions } from './createBalanceSlice';
import { FilterBalanceType } from '../../components/Balance/FilterType';

/**
 * @french
 * Hook Zustand persistant pour la gestion de la balance comptable.
 */
export const useBalanceStore = create<BalanceState & BalanceActions>()(
  persist(combine(balanceInitialState, createBalanceSlice as any), {
    name: 'balance-store',
    partialize: (state) => ({
      ...state,
      savedFilters: Array.from(state.savedFilters.entries()),
    }),
    merge: (persistedState: any, currentState) => ({
      ...currentState,
      ...persistedState,
      savedFilters: new Map(persistedState.savedFilters as [FilterBalanceType, any][]),
    }),
  }),
);
